import { combineReducers } from "redux";
import launcherapi from "./launcherapi";

export default combineReducers({ launcherapi });
